export default class CurrencyFormatter {
  /**
   * @param {string} bcp47LanguageTag
   * @param {string} iso4217CurrencyCode
   */
  constructor(bcp47LanguageTag, iso4217CurrencyCode) {
    this.formatter = new Intl.NumberFormat(bcp47LanguageTag, { style: 'currency', currency: iso4217CurrencyCode });
  }

  /**
   * @param {number} amount
   */
  format(amount) {
    return this.formatter.format(amount);
  }
}



// WEBPACK FOOTER //
// ./V7/tnew/currency/CurrencyFormatter.js